import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  label: 'EID number*',
  placeholder: 'Enter 32 digit EID number',
  state: 'none',
  useStateHintColor: false,
  isDisabled: false,
  theme: 'light',
  showLoader: false,
  showDivider: false,
  enableAutocomplete: false,
  autoCompleteFilterKey: 'title',
  autoCompleteValueKey: 'title',
  value: '',
  showListLoader: false,
  containerStyle: {},
  analyticsData: {},
  prependItems: {
    prefixIcon: {
      iconName: 'UserIcon'
    },
    prefixText: '+91',
    text: 'prepend',
    postfixIcon: {
      iconName: 'DownChevronButtonIcon'
    },
    isPressable: true,
    onPress: {}
  },
  appendItems: {
    prefixIcon: {
      iconName: 'UserIcon'
    },
    text: 'append',
    postfixIcon: {
      iconName: 'DownChevronButtonIcon'
    },
    textAsAction: true,
    isPressable: true,
    onPress: {}
  },
  showInputDivider: true
}, getTestId('InputWidgetContainer'));